import { get, post, put, deleted } from '..';
import routes from './routes';

const RoleServices = {
  getRoles: async (params) => {
    const data = await get(routes.getRoles, params);
    return data;
  },

  getRoleById: async (roleId) => {
    const data = await get(routes.getRoleById.replace(':role_id', roleId));
    return data;
  },

  createRole: async (roleData) => {
    const data = await post(routes.createRole, roleData);
    return data;
  },

  updateRole: async (roleId, roleData) => {
    const data = await put(routes.updateRole.replace(':role_id', roleId), roleData);
    return data;
  },

  deleteRole: async (roleId) => {
    const data = await del(routes.deleteRole.replace(':role_id', roleId));
    return data;
  },

  getRolePermissions: async (roleId) => {
    const data = await get(routes.getRolePermissions.replace(':role_id', roleId));
    return data;
  },

  assignPermissionsToRole: async (roleId, permissions) => {
    const data = await post(routes.assignPermissions.replace(':role_id', roleId), { permissions: permissions || [] });
    return data;
  },

  removePermissionsFromRole: async (roleId, permissions) => {
    const data = await deleted(routes.removePermissions.replace(':role_id', roleId), { permissions });
    return data;
  }
};

export default RoleServices;